module.exports = __webpack_public_path__ + "static/media/apartment13.dfa2e447.jpg";